import React, { createElement, useMemo } from 'react';
import type { FC, ReactNode } from 'react';
import { isCliSystemError, normalizeError } from '@wix/cli-error';
import { getErrorComponent } from '../get-error-component.js';
import { HttpErrorDetails } from './HttpErrorDetails.js';

interface Props {
  error: unknown;
  systemErrorOverride?: ReactNode;
}

export const ErrorViewer: FC<Props> = ({
  error: originalError,
  systemErrorOverride,
}) => {
  const userFriendlyMessage = useMemo(() => {
    const error = normalizeError(originalError);

    return isCliSystemError(error) && systemErrorOverride
      ? systemErrorOverride
      : createElement(getErrorComponent(error.cliCode, error.cause()));
  }, [originalError, systemErrorOverride]);

  return (
    <>
      {userFriendlyMessage}
      <HttpErrorDetails error={originalError} />
    </>
  );
};
